import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/app/ad',
  component: Layout,
  name: 'AppAd',
  meta: {
    title: '广告管理',
    icon: 'mdi:bullhorn',
  },
  children: [
    {
      path: 'exposure',
      name: 'AppAdExposureList',
      component: () => import('@/views/app/ad/exposure/list.vue'),
      meta: {
        title: '曝光统计',
      },
    },
  ],
}

export default routes
